import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import { useAuthStore } from '@/stores/auth';

export function useMe() {
  const q = useQuery({
    queryKey: ['auth', 'me'],
    queryFn: () => api.auth.me(),
    retry: false,
    // 401 같은 인증 오류도 던지지만 캐싱은 그대로 사용
    throwOnError: false,
  });

  const setUser = useAuthStore((s) => s.setUser);

  useEffect(() => {
    if (q.isSuccess) setUser(q.data);
    else if (q.isError) setUser(null);
  }, [q.isSuccess, q.isError, q.data, setUser]);

  return q;
}
